/**
* 头部菜单
*/ 
<template>
  <div class="head-bar">
    <!-- <el-button class="buttonimg"  @click="toggle(collapsed)">
      <i v-if="collapsed" class="el-icon-s-fold"></i>
      <i v-else class="el-icon-s-unfold"></i>
    </el-button> -->
    <!-- <span style="margin-right: 15px">{{ user.username }}</span> -->
    <el-dropdown style="margin-right: 15px; cursor: pointer">
      <span class="el-dropdown-link">
        {{ user.username }}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <!-- <el-button type="primary" size="small">
        {{ user.username }}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </el-button> -->
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="(user, index) in userList"
          :key="index"
          @click.native="switchAccount(user)"
        >
          <el-tooltip placement="left">
            <div slot="content">{{ user.username }}</div>
            <div class="truncate-text">{{ user.username }}</div>
          </el-tooltip>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dropdown style="margin-right: 25px; cursor: pointer">
      <span class="el-dropdown-link">
        个人中心
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown" style="width: 100px">
        <el-dropdown-item @click.native="editPasswd()"
          >修改密码</el-dropdown-item
        >
        <el-dropdown-item v-if="roleId === 3" @click.native="showPaymentInfo()"
          >收款信息</el-dropdown-item
        >
        <el-dropdown-item @click.native="exit()">退出</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
    >
      <el-form
        :model="passwordForm"
        :rules="passwordRules"
        ref="passwordForm"
        label-width="100px"
      >
        <el-form-item label="密码类型">
          <el-radio-group v-model="passwordForm.passwordType">
            <el-radio label="login">登录密码</el-radio>
            <el-radio label="payment">支付密码</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input
            size="small"
            type="password"
            v-model="passwordForm.oldPassword"
            placeholder="请输入旧密码"
            show-password
          >
          </el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            size="small"
            type="password"
            v-model="passwordForm.newPassword"
            placeholder="请输入新密码"
            show-password
          >
          </el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input
            size="small"
            type="password"
            v-model="passwordForm.confirmPassword"
            placeholder="请再次输入新密码"
            show-password
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="onCancel">取 消</el-button>
        <el-button size="small" type="primary" @click="submitPassword"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="收款信息" :visible.sync="payDialogVisible" width="500px">
      <el-form
        :model="payInfoForm"
        :rules="payInfoRules"
        ref="payInfoForm"
        label-width="100px"
      >
        <el-form-item label="收款方式：" prop="type">
          <el-radio-group v-model="payInfoForm.type">
            <el-radio label="1">个人</el-radio>
            <el-radio label="2">公司</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="payInfoForm.type == '2'">
          <el-form-item label="开票类型：" prop="invoiceType">
            <el-select
              v-model="payInfoForm.invoiceType"
              placeholder="请选择开票类型"
              clearable
              size="small"
              style="width: 90%"
            >
              <el-option
                v-for="item in invoiceTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item label="收款户名：" prop="payeeName">
          <el-input
            size="small"
            v-model="payInfoForm.payeeName"
            placeholder="请输入收款户名"
            style="width: 90%"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item label="收款账号：" prop="payeeAccount">
          <el-input
            size="small"
            v-model="payInfoForm.payeeAccount"
            placeholder="请输入收款账号"
            style="width: 90%"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item label="开户行：" prop="depositBank">
          <el-input
            size="small"
            v-model="payInfoForm.depositBank"
            placeholder="请输入开户行"
            style="width: 90%"
            clearable
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="onCancelPay">取 消</el-button>
        <el-button size="small" type="primary" @click="submitPayInfo"
          >修 改</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  loginout,
  userPwd,
  getSwitchAccount,
  getAllAccounts,
  getAgentUserInfo,
  updateAgentPayeeInfo,
} from "../api/userMG";
export default {
  name: "navcon",
  data() {
    return {
      invoiceTypeOptions: [
        { label: "专票1%", value: 1 },
        { label: "专票6%", value: 2 },
      ],
      roleId: "",
      agentInfo: {},
      userList: [],
      collapsed: true,
      imgshow: require("../assets/img/show.png"),
      imgsq: require("../assets/img/sq.png"),
      user: {},
      dialogVisible: false, // 控制修改密码对话框是否显示
      payDialogVisible: false,
      passwordForm: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
        passwordType: "login", // 新增，用于记录选择的密码类型，初始为登录密码
      },

      payInfoForm: {
        type: "",
        invoiceType: "",
        payeeName: "",
        payeeAccount: "",
        depositBank: "",
      },
      passwordRules: {
        oldPassword: [
          { required: true, message: "请输入旧密码", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 8, message: "新密码长度至少为8位", trigger: "blur" },
        ],
        confirmPassword: [
          {
            required: true,
            message: "请再次输入新密码",
            trigger: "blur",
          },
          {
            validator: this.validateConfirmPassword,
            trigger: "blur",
          },
        ],
      },
      payInfoRules: {
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        payeeName: [
          { required: true, message: "请输入收款户名", trigger: "blur" },
        ],
        depositBank: [
          { required: true, message: "请输入开户行", trigger: "blur" },
        ],
        payeeAccount: [
          { required: true, message: "请输入收款账号", trigger: "blur" },
          { pattern: /^\d+$/, message: "收款账号必须为数字", trigger: "blur" },
        ],
      },
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.user = JSON.parse(localStorage.getItem("user_info"));
    this.roleId = this.user.roleId;
    // 商户才提供切换账号
    if (this.user && (this.user.roleId === 0 || this.user.roleId === 2)) {
      // 商户 风控
      this.getAllAccount();
    }
    // 代理商
    else if (this.user && this.user.roleId === 3) {
      this.getAgentInfo();
    }
  },
  methods: {
    getAgentInfo() {
      getAgentUserInfo().then((res) => {
        if (res.msg === "success") {
          this.agentInfo = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    switchAccount(user) {
      getSwitchAccount({ switchUserId: user.userId }).then((res) => {
        if (res.msg === "success") {
          localStorage.setItem("logintoken", res.data);
          localStorage.setItem("user_info", JSON.stringify(user));
          this.user = user;
          // 切换账号成功后刷新页面
          window.location.reload();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getAllAccount() {
      getAllAccounts().then((res) => {
        if (res.msg === "success") {
          this.userList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    onCancel() {
      // 重置表单验证状态
      this.$refs.passwordForm.resetFields();
      // 清空密码输入框的值
      this.passwordForm.oldPassword = "";
      this.passwordForm.newPassword = "";
      this.passwordForm.confirmPassword = "";
      this.passwordForm.passwordType = "login";
      this.dialogVisible = false;
    },
    handleClose() {
      // 重置表单验证状态
      this.$refs.passwordForm.resetFields();
      // 清空密码输入框的值
      this.passwordForm.oldPassword = "";
      this.passwordForm.newPassword = "";
      this.passwordForm.confirmPassword = "";
      this.passwordForm.passwordType = "login";
      this.dialogVisible = false;
    },

    onCancelPay() {
      this.payDialogVisible = false;
    },

    // 验证确认新密码是否与新密码一致
    validateConfirmPassword(rule, value, callback) {
      if (value === this.passwordForm.newPassword) {
        callback();
      } else {
        callback(new Error("两次输入的新密码不一致"));
      }
    },
    editPasswd() {
      this.dialogVisible = true;
      // 重置表单验证状态
      this.$refs.passwordForm.resetFields();
      // 清空密码输入框的值
      this.passwordForm.oldPassword = "";
      this.passwordForm.newPassword = "";
      this.passwordForm.confirmPassword = "";
      this.passwordForm.passwordType = "login";
    },
    submitPassword() {
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          const formData = new FormData();
          formData.append("userId", this.user.userId);
          formData.append("oldPassword", this.passwordForm.oldPassword);
          formData.append("newPassword", this.passwordForm.newPassword);
          formData.append("passwordType", this.passwordForm.passwordType);
          userPwd(formData)
            .then((res) => {
              if (res.msg === "success") {
                this.dialogVisible = false;
                this.$message({
                  type: "success",
                  message: "密码修改成功!",
                });
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              this.$message.error("密码修改失败，请稍后再试！");
            });
        }
      });
    },
    showPaymentInfo() {
      if (this.agentInfo == null) {
        this.$message.error("后台还未配置，请联系管理员配置代理商");
        return;
      }
      this.payDialogVisible = true;
      this.payInfoForm.type = String(this.agentInfo.type);
      this.payInfoForm.payeeName = this.agentInfo.payeeName;
      this.payInfoForm.payeeAccount = this.agentInfo.payeeAccount;
      this.payInfoForm.depositBank = this.agentInfo.depositBank;
      this.payInfoForm.invoiceType = this.agentInfo.invoiceType || "";
    },
    submitPayInfo() {
      if (this.payInfoForm.type != String(this.agentInfo.type)) {
        this.$confirm("更换收款方式会影响计算佣金方式, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$refs.payInfoForm.validate((valid) => {
              if (valid) {
                updateAgentPayeeInfo(this.payInfoForm)
                  .then((res) => {
                    if (res.msg === "success") {
                      this.onCancelPay();
                      this.getAgentInfo();
                      this.$message({
                        type: "success",
                        message: "修改成功!",
                      });
                    } else {
                      this.$message.error(res.msg);
                    }
                  })
                  .catch((err) => {
                    this.$message.error("修改失败，请稍后再试！");
                  });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$refs.payInfoForm.validate((valid) => {
          if (valid) {
            updateAgentPayeeInfo(this.payInfoForm)
              .then((res) => {
                if (res.msg === "success") {
                  this.onCancelPay();
                  this.getAgentInfo();
                  this.$message({
                    type: "success",
                    message: "修改成功!",
                  });
                } else {
                  this.$message.error(res.msg);
                }
              })
              .catch((err) => {
                this.$message.error("修改失败，请稍后再试！");
              });
          }
        });
      }
    },
    // 退出登录
    exit() {
      this.$confirm("退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          loginout()
            .then((res) => {
              if (res.msg == "success") {
                //如果请求成功就让他2秒跳转路由
                setTimeout(() => {
                  localStorage.removeItem("logintoken");
                  localStorage.removeItem("user_info");
                  this.$router.push({ path: "/login" });
                  this.$message({
                    type: "success",
                    message: "已退出登录!",
                  });
                }, 1000);
              } else {
                this.$message.error(res.msg);
                this.logining = false;
                return false;
              }
            })
            .catch((err) => {
              localStorage.removeItem("logintoken");
              this.$router.push({ path: "/login" });
              this.logining = false;
              this.$message.error("退出失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype;
      this.$root.Bus.$emit("toggle", this.collapsed);
    },
  },
};
</script>
<style scoped>
.head-bar {
  box-sizing: border-box;
  height: 60px;
  min-height: 60px;
  max-height: 60px;
  margin: 0;
  background-color: #fff;
  color: #272727;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-bottom: 1px solid #ccc;
  box-shadow: 0px 4px 15px 0px rgba(92, 133, 168, 0.1);
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
.submenu {
  float: right;
}
.buttonimg {
  height: 60px;
  background-color: transparent;
  border: none;
}
.buttonimg i {
  font-size: 25px;
}

.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}
.showimg:active {
  border: none;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.el-dropdown-menu {
  max-height: 300px;
  overflow-y: auto;
}
.truncate-text {
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>


// WEBPACK FOOTER //
// src/components/navcon.vue